import { DataFromCronos } from '@services/withData';
import { extractDataFromHTML } from '@utils/extractDataFromHTML';
import { getOverrideExperiments } from '@utils/getOverrideExperiments';
import { useAppSetting } from '@contexts/appSetting/hooks/useAppSetting';
import { AppSetting } from '@ul/appsetting-model/dist/model/appSetting';
import { AppSettingContextData } from '@contexts/appSetting/AppSettingContext';

export function getDataFromCronos(root: HTMLElement, appSetting: AppSettingContextData): DataFromCronos {
    const isCrossDomain = appSetting.tokenGrantType?.parentWhitelistedOrigin != '';
    const dataFromRoot = <TKey extends keyof DataFromCronos>(key: TKey) =>
        extractDataFromHTML(root)(key, {} as DataFromCronos[TKey]);
    return {
        cms: dataFromRoot('cms'),
        experiments: dataFromRoot('experiments'),
        overrideExperiments: isCrossDomain ? {} : getOverrideExperiments(),
    };
}
